import { useEffect, useState } from "react";
import { jeuQuestions } from "../lib/api.ts";
import { useApp } from "../app/state.tsx";
import { Panneau } from "../admin/ui.tsx";

/** C2 — Gamification côté joueur. Questions réelles (créées par le bureau) ; +1 point par bonne réponse. */
interface QuestionJeu { q: string; r: string[]; bonne: number }

export function Gamification(): React.ReactElement {
  const app = useApp();
  const [questions, setQuestions] = useState<QuestionJeu[] | null>(null);
  const [points, setPoints] = useState(0);
  const [i, setI] = useState(0);
  const [repondu, setRepondu] = useState<number | null>(null);

  useEffect(() => {
    jeuQuestions(app.edition.id)
      .then((res) => setQuestions(res.entites.map((e) => {
        const d = e.donnees as Record<string, unknown>;
        return { q: String(d.texte ?? ""), r: [d.r1, d.r2, d.r3].map((x) => String(x ?? "")).filter(Boolean), bonne: Number(d.bonne ?? 1) - 1 };
      }).filter((x) => x.r.length >= 2)))
      .catch(() => setQuestions([]));
  }, [app.edition.id]);

  if (questions === null) return <p style={{ color: "var(--muted)" }}>Chargement…</p>;
  if (questions.length === 0) {
    return <div style={{ maxWidth: 640 }}><Panneau titre="Gamification" sous="Le jeu de cette édition n'a pas encore de questions."><p style={{ margin: 0, color: "var(--muted)", fontSize: 13.5 }}>Le bureau prépare les questions ; revenez bientôt. Chaque exposant scanné vous rapporte déjà des points.</p></Panneau></div>;
  }
  const total = questions.length;
  const q = questions[i] as QuestionJeu;

  function repondre(choix: number): void {
    if (repondu !== null) return;
    setRepondu(choix);
    if (choix === q.bonne) setPoints((p) => p + 1);
  }
  function suivante(): void { setRepondu(null); setI((n) => (n + 1) % total); }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 720 }}>
      <div className="card" style={{ padding: 20, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
        <div><span className="eyebrow">Mes points</span><div className="display" style={{ fontSize: 30 }}>{points}</div></div>
        <div style={{ textAlign: "right" }}><span className="eyebrow">Question</span><div className="display" style={{ fontSize: 18 }}>{i + 1}<span style={{ color: "var(--muted-2)", fontSize: 14 }}> / {questions.length}</span></div></div>
      </div>

      <Panneau titre={`Question ${i + 1}`} sous="Les réponses s'obtiennent en allant voir les exposants.">
        <p style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{q.q}</p>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {q.r.map((r, k) => {
            const juste = repondu !== null && k === q.bonne;
            const faux = repondu === k && k !== q.bonne;
            return (
              <button key={r} onClick={() => repondre(k)} disabled={repondu !== null}
                style={{ textAlign: "left", padding: "12px 14px", borderRadius: 10, cursor: repondu === null ? "pointer" : "default", fontSize: 13.5, fontWeight: 600,
                  border: `1px solid ${juste ? "var(--ok)" : faux ? "var(--danger)" : "var(--line-2)"}`,
                  background: juste ? "var(--ok-bg)" : faux ? "var(--danger-bg)" : "var(--surface)",
                  color: juste ? "var(--ok)" : faux ? "var(--danger)" : "var(--ink-2)" }}>{r}</button>
            );
          })}
        </div>
        {repondu !== null && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontSize: 13, color: repondu === q.bonne ? "var(--ok)" : "var(--danger)", fontWeight: 600 }}>{repondu === q.bonne ? "+1 point !" : "Pas cette fois."}</span>
            <button className="btn btn-primary" onClick={suivante}>Question suivante</button>
          </div>
        )}
      </Panneau>
    </div>
  );
}
